setTimeout(() => {
    if(BSS_B2B){
        let interval = setInterval(() => {
            const ele = document.querySelector('.bss-b2b-search-bar');
            if(ele){
                clearInterval(interval)
                const observerMutation = new MutationObserver((MutationList) => {
                    for(let item of MutationList){
                        if(item.target.className.includes('js_prs_search') && item.type === 'childList'){
                            console.log(123);
                            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                        }
                    }
                })
                observerMutation.observe(ele, {childList: true, subtree: true})
            }
            
        }, 200);
        setTimeout(() => clearInterval(interval), 5000);

        //quickview

        const observerMutation = new MutationObserver((MutationList) => {
            for(let item of MutationList){
                if(item.target.localName === 'body' && item.addedNodes.length){
                    if(item.addedNodes[1]?.className?.includes('mfp-wrap')){
                        console.log(1234);
                        const wrap = document.querySelector('.mfp-content');
                        if(wrap){
                                wrap.setAttribute('bss-b2b-quickview-product-form', '');
                                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                        }
                        // BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                    }
                }
            }
        })
        observerMutation.observe(document.body, {childList: true, subtree: true, attrbutes: true})
    }
}, 300)